import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  questions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '1rem',
    border: `1px solid ${Colors.gray}`,
    borderRadius: 3,
    backgroundColor: Colors.lightGray,
    textAlign: 'justify',
    height: '100%',
    minHeight: '16rem',
    gap: '1rem',
  },
  
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  
  statusBar: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  
  status: {
    padding: '0.5rem 1rem',
    textTransform: 'uppercase',
    color: Colors.white,
    fontSize: 11,
    backgroundColor: Colors.green,
    borderRadius: '3px',
    fontWeight: 'bold',
  },
  
}))

export default styles
